const AboutHyfye = () => {
    return (
      <section id="about" className="small_pt">
        <div className="container">
          <div className="row align-items-center">
            
            {/* Image Section */}
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="text-center">
                <img
                  className="animation"
                  data-animation="zoomIn"
                  data-animation-delay="0.2s"
                  style={{ width: "70%" }}
                  src="assets/images/blockchain.webp"
                  alt="Hyfye Blockchain"
                />
              </div>
            </div>
  
            {/* Content Section */}
            <div className="col-lg-6 col-md-12 col-sm-12 res_md_mt_40 res_sm_mt_40 res_xs_mt_30">
              <div className="title_dark title_border text_md_center">
                
                <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                  About Hyfye
                </h4>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">
                  <strong>Hyfye</strong> is a global decentralized digital currency created to turn gratitude into real-world value. It is the world’s first truly universal <strong>Tip Coin</strong> designed to reward every meaningful action, both online and offline.
                </p>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                  Whether you like a post, leave a comment, share a video, enjoy a service, or tip a creator — Hyfye makes showing appreciation simple, instant, and rewarding.
                </p>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.5s">
                  Built on a decentralized blockchain ledger, Hyfye ensures full transparency, fairness, and community-driven governance — without banks, borders, or intermediaries.
                </p>
  
                <h5 className="animation" data-animation="fadeInUp" data-animation-delay="0.7s">
                  🌟 Phase 1: Launching Hyfye Tip Coin (HYE)
                </h5>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="0.8s">
                  Hyfye Coin (HYE) is the foundation — empowering instant, borderless tips across social media, live events, online platforms, and real-world services.
                </p>
  
                <h5 className="animation" data-animation="fadeInUp" data-animation-delay="0.9s">
                  🚀 Phase 2: Building the Hyfye Global Economy
                </h5>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="1s">
                  We are creating a full decentralized platform where users can <strong>earn, buy, sell, and tip</strong> — connecting content creators, service providers, viewers, freelancers, and participants into one powerful global ecosystem.
                </p>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="1.1s">
                  Even everyday actions like <strong>signing up</strong>, <strong>watching videos</strong>, <strong>commenting</strong>, or <strong>participating</strong> in activities will earn users Hyfye Coins. Every action matters.
                </p>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="1.2s">
                  As the Hyfye community grows, the value of every tip, every post, and every connection strengthens — powered by real appreciation and participation.
                </p>
  
                <p className="animation" data-animation="fadeInUp" data-animation-delay="1.3s">
                  <strong>Join the Hyfye movement</strong> — where every thank you becomes a real opportunity. 🌎✨
                </p>
  
              </div>
            </div>
  
          </div>
        </div>
      </section>
    );
  };
  
  export default AboutHyfye;
  